import Title from "../../common/Title/Title";
import "./ArticleCard.css";
import { Link } from "react-router-dom";

export default function ArticleCard({ imageSrc, title, description, link, readMore }) {
  return (
    <div className="article-card">
      <img src={imageSrc} alt={title} className="article-card-image" />
      <div className="article-card-content">
        <Title text={title} size={["1.4rem", "1.2rem"]} />
        <p className="article-card-description">{description}</p>
        <Link to={link} className="article-card-link">{readMore}</Link>
      </div>
    </div>
  );
}
